import React, { useEffect, useState } from 'react';
import '../../common/scss/tag.selectbox.scss';
import { useHistory } from 'react-router-dom';
import {
  EDIT_CAPTAIN,
  PARTNER_EDIT_TREEHOUSE,
  SCHOOL_ADD_CHALLENGES,
} from '../../../constants/routes.constants';
import { useAuth } from '../../auth/Auth';
import CampUnverifiedModal from '../../common/CampUnverifiedModal';
import InviteModal from './camp_invite/InviteModal';
import { useRecoilState } from 'recoil';
import { stepsEnabledAtom } from '../../../atoms/camp.atom';
import flagIcon from '../../../../src/assets/icon/icon-my-room-flag.svg';
import tribeIcon from '../../../../src/assets/icon/Tribes.svg';
import captainIcon from '../../../../src/assets/icon/Captains.svg';
import guardianIcon from '../../../../src/assets/icon/Guardians_icon.svg';
import CampRestrictModal from './CampRestrictModal';

const CampAddDropdown = () => {
  const [stepsEnabled, setStepsEnabled] = useRecoilState(stepsEnabledAtom);
  const history = useHistory();
  const { school } = useAuth();
  const [showPane, setShowPane] = useState(stepsEnabled ? true : false);
  const [rotate, setRotate] = useState('');
  const [tagOn, setTagOn] = useState(false);
  const [showUnverifiedCampModal, setShowUnverifiedCampModal] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showRestrictCampModal, setShowRestrictCampModal] = useState(false);
  const list = [
    { id: 1, name: 'Tribes' },
    { id: 2, name: 'Captains' },
    { id: 3, name: 'Guardians' },
    { id: 4, name: 'Challenges' },
  ];

  useEffect(() => {
    setShowPane(stepsEnabled ? true : false);
  }, [stepsEnabled]);

  const rotateArrow = () => {
    setRotate(rotate === 'rotate-180' ? 'rotate-360' : 'rotate-180');
  };

  const handleSelectboxClick = (e) => {
    setShowPane(!showPane);
    rotateArrow();
  };

  const handleClick = (e) => {
    if (!school?.is_verified) {
      setShowUnverifiedCampModal(true);
      return;
    }
    const tag = Number(e.target.dataset.tag);
    if (tag === 1) history.push(PARTNER_EDIT_TREEHOUSE);
    if (tag === 2) history.push(EDIT_CAPTAIN);
    if (tag === 3) setShowInviteModal(true);
    if (tag === 4) onAddChallenge(true);
    setShowPane(false);
    rotateArrow();
  };

  const getIcon = (id) => {
    switch (id) {
      case 1:
        return tribeIcon;
      case 2:
        return captainIcon;
      case 3:
        return guardianIcon;
      case 4:
        return flagIcon;
      default:
        break;
    }
  };

  const onAddChallenge = () => {
    if (!school?.is_verified) {
      setShowUnverifiedCampModal(true);
      return;
    }
    if (school?.subcription_type !== 'premium') {
      setShowRestrictCampModal(true);
      return;
    }
    if (school) {
      history.push({
        pathname: SCHOOL_ADD_CHALLENGES,
        state: {
          treehouseId: 'All',
          treehouse_agora_group_id: '',
          selectedTribe: JSON.stringify('All'),
          isCampMaster: true,
        },
      });
    }
  };

  return (
    <div className="tagSelectbox-container kids-in-partner">
      {showUnverifiedCampModal && (
        <CampUnverifiedModal
          showModal={showUnverifiedCampModal}
          setShowModal={setShowUnverifiedCampModal}
        />
      )}
      {showRestrictCampModal && (
        <CampRestrictModal
          showModal={showRestrictCampModal}
          setShowModal={setShowRestrictCampModal}
        />
      )}
      <InviteModal
        fromDashboard={true}
        showModal={showInviteModal}
        setShowModal={setShowInviteModal}
      />
      <div
        className={`filter tag-selectbox  camp-add-dropdown ${tagOn ? 'tag-selected' : ''
          }`}
        onClick={handleSelectboxClick}
      >
        <div className="selected-tag">Add</div>
        <div className={`selectbox-arrow ${rotate}`}></div>
      </div>
      <div className={`tag-list-pane ${showPane ? 'show' : 'hide'}`}>
        {list.map((item, key) => {
          return (
            <div
              id={`step-${item?.id === 1 ? 'two' : item?.id === 2 ? 'three' : 'four'
                }`}
              className="tag-item imgdropdown"
              onClick={handleClick}
              data-tag={item?.id}
              key={`item-${key}`}
              style={{ gap: '15px' }}
            >
              <div
                className="dropdown_img_center add-pointer"
                data-tag={item?.id}
                onClick={handleClick}
              >
                <img
                  data-tag={item?.id}
                  onClick={handleClick}
                  src={getIcon(item?.id)}
                  alt={item?.name}
                  style={{ height: '20px', width: '30px' }}
                />{' '}
                {item?.name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CampAddDropdown;
